import { push } from 'connected-react-router';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const ACCOUNT_WITHHOLDING_OPEN_MODAL = 'ACCOUNT_WITHHOLDING_OPEN_MODAL';
export const ACCOUNT_WITHHOLDING_CLOSE_MODAL = 'ACCOUNT_WITHHOLDING_CLOSE_MODAL';
export const ACCOUNT_WITHHOLDING_REQUEST = 'ACCOUNT_WITHHOLDING_REQUEST';
export const ACCOUNT_WITHHOLDING_SUCCESS = 'ACCOUNT_WITHHOLDING_SUCCESS';
export const ACCOUNT_WITHHOLDING_FAILURE = 'ACCOUNT_WITHHOLDING_FAILURE';
export const IMYTREE_WITHHOLDING_FLAG = 'IMYTREE_WITHHOLDING_FLAG';
export const POOLED_RATES_OPEN_MODAL = 'POOLED_RATES_OPEN_MODAL';
export const POOLED_RATES_CLOSE_MODAL = 'POOLED_RATES_CLOSE_MODAL';

function openAccountWithholdingModal() {
  return {
    type: ACCOUNT_WITHHOLDING_OPEN_MODAL
  };
}

function closeAccountWithholdingModalModal() {
  return {
    type: ACCOUNT_WITHHOLDING_CLOSE_MODAL
  };
}

function requestAccountWithholding() {
  return {
    type: ACCOUNT_WITHHOLDING_REQUEST
  };
}

function setImyTreeWithholdingFlag(flag) {
  return {
    type: IMYTREE_WITHHOLDING_FLAG,
    showRate: flag
  };
}

function receiveAccountWithholding(accountWithholding) {
  return {
    type: ACCOUNT_WITHHOLDING_SUCCESS,
    accountWithholding
  };
}

function rejectAccountWithholding() {
  return {
    type: ACCOUNT_WITHHOLDING_FAILURE
  };
}

function openPooledRatesModal(guid, rates) {
  return {
    type: POOLED_RATES_OPEN_MODAL,
    pooledRates: rates,
    selectedPooledAccount: guid
  };
}

function closePooledRatesModal() {
  return {
    type: POOLED_RATES_CLOSE_MODAL
  };
}

// In ideal scenario it would be preferrable to have this abstracted out between form and customer
function getWithholdingRates(formId, customerId, accountId) {
  return (dispatch) => {
    dispatch(requestAccountWithholding());
    const promise = () => ApiService
      .getDetectedWithholdingRates(formId, customerId, accountId)
      .then(response => dispatch(receiveAccountWithholding(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAccountWithholding, true));
        }
      });
    return promise();
  };
}

export function getImyTreeWithholdingRates() {
  return (dispatch) => {
    dispatch(setImyTreeWithholdingFlag(true));
  };
}

export function resetImyTreeWithholdingRatesFlag() {
  return (dispatch) => {
    dispatch(setImyTreeWithholdingFlag(false));
  };
}

export function showImyTreeWithholding(formId, accountId, versionNumber) {
  return (dispatch) => {
    dispatch(getImyTreeWithholdingRates());
    if (typeof versionNumber !== 'undefined' && versionNumber !== null) {
      return dispatch(push(`/w8imystructure/${ formId }/${ accountId }/${ versionNumber }`));
    }
    return dispatch(push(`/w8imystructure/${ formId }/${ accountId }`));
  };
}

export function hideImyTreeWithholding() {
  return (dispatch) => {
    dispatch(resetImyTreeWithholdingRatesFlag());
  };
}

export function showAccountWithholdingModal(formId, customerId, accountId) {
  return (dispatch) => {
    dispatch(getWithholdingRates(formId, customerId, accountId));
    return dispatch(openAccountWithholdingModal());
  };
}

export function hideAccountWithholdingModal() {
  return (dispatch) => {
    dispatch(closeAccountWithholdingModalModal());
  };
}

export function switchAccountForWithholding(accountId) {
  return (dispatch) => {
    dispatch(getWithholdingRates(null, null, accountId));
  };
}

export function showPooledRatesModal(guid, rates) {
  return (dispatch) => {
    dispatch(openPooledRatesModal(guid, rates));
  };
}

export function hidePooledRatesModal() {
  return (dispatch) => {
    dispatch(closePooledRatesModal());
  };
}
